module.exports = __webpack_public_path__ + "static/media/win.db355d5b.png";